<div class="container">
  <app-base-common-table-portal [context]="this"></app-base-common-table-portal>
  <mat-progress-bar
    *ngIf="isLoading"
    class="app-loading-bar"
    color="primary"
    mode="indeterminate">
  </mat-progress-bar>
  <ng-template #actionsColumn let-row="row">
    <button
      mat-flat-button
      class="outline-button icon-button"
      (click)="nav(['/scheduled-event/', row.id])">
      <fa-icon
        [icon]="['fas', 'eye']"
      ></fa-icon>
    </button>
  </ng-template>
</div>
